import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  assignments: [],
  exceptions: [],
  facilities: [], 
  stopStates: {},
  activityView: 'day',
  dateFrom: '2026-04-07',
  dateTo: '2026-04-07',
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    addAssignments(state, action) {
      state.assignments = action.payload;
    },
    setActivityView(state, action) {
      state.activityView = action.payload;
    },
    setDateRange(state, action) {
      state.dateFrom = action.payload.from;
      state.dateTo = action.payload.to;
    },
    addExceptions(state, action) {
      state.exceptions = action.payload;
    },
    addFacilities(state, action) {
      state.facilities = action.payload;
    },
    setStopStatus(state, action) {
      state.stopStates = action.payload;
    }
  },
});

export const { setActivityView, setDateRange, addExceptions, addFacilities, setStopStatus, addAssignments } = adminSlice.actions;
export default adminSlice.reducer;
